var ctrlopt = ctrlopt,
  generic = generic || {},
  FB = FB || '',
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings || {};
  var oab = settings.oab || {};
  var time_interval = oab.time_interval;
  var oab_date_override = oab.oab_override_date_format || 0;
  var oab_date_month_separator = oab.oab_date_month_separator || ' ';
  var oab_date_month_override = oab.oab_override_date_month_format || 0;
  var oab_show_year_text_at_last = oab.oab_show_year_text_at_last || 0;
  var start_day = oab.oab_datepicker_start_day || 0;
  var oab_date_format = settings.oab_date_format || 0;
  var oab_show_year_suffix = settings.oab_show_year_suffix || 0;
  var oab_show_month_after_year = settings.oab_show_month_after_year || 0;
  var oab_email_required_err_msg = settings.oab_email_required_err_msg || 0;
  var oab_error_password_required = settings.oab_error_password_required || 0;
  var oab_send_sms_default = oab.oab_send_sms_default || 0;
  var jsconfig_settings = Drupal.settings.global_variables || {};
  var phone1Input, phone2Input, apptKRPhoneCode, apptKrSelectPhoneCode;

  /* optional day number override function used when we need to generate calendar table starting from monday; when global var start_day is not defined, output value is untouched */
  function startDayShift(day_nr) {
    day_nr = day_nr - start_day;
    if (day_nr == -1) {
      day_nr = 6;
    }

    return day_nr;
  }

  /* Concrete View */
  apptBook.AppointmentSelectSection = function (container) {
    apptBook.AppointmentSelectSection.superclass.constructor.call(this);
    this.id = 'appointments';
    this.jqBod = $('body');
    this.container = container;
    this.servContainer = container.find('.services');
    this.serviceTmpl = this.servContainer.find('.service').remove();
    this.changeServices = container.find('#change-services-link');
    this.backTo = container.find('.back-to-link');
    this.minLabel = this.servContainer.attr('data-time-label');
    this.locSelect = container.find('select.location-select');
    this.artContainer = container.find('.artist-select-container');
    this.artSelect = this.artContainer.find('select.artist-select');
    this.artAnyValue = this.artSelect.attr('data-artist-any-value');
    this.apptContainer = container.find('.appointment-select');
    this.signInContainer = container.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.confirm-container');
    this.totalElem = this.confContainer.find('.total-time');
    this.totalText = this.totalElem.html();
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.appointmentTime = null;
    this.totalTime = 0;
    this.serviceIds = [];
    this.stores = {};
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.AppointmentSelectSection, apptBook.AbstractSection);

  apptBook.AppointmentSelectSection.prototype.onUpdate = function (data) {
    var servs, servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Appointment Select & Book';

    this.serviceIds = [];
    this.totalTime = 0;
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildServices();
        me.buildLocation();
        me.buildArtists();
        if (!me.initialized) {
          me.buildApptSelect();
          me.initialized = true;
        } else {
          me.calModel.update({
            date: new Date(),
            calendarId: me.calendarId,
            counterId: me.counterId,
            serviceIds: me.serviceIds,
            hilite: true
          });
        }

        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(data.params.appointmentId, function (apptData) {
          me.appointmentData = apptData;
          me.updateMode = true;
          me.counterId = me.appointmentData.counter_id;
          me.calendarId = me.appointmentData.calendar_id;
          me.servicesData = [];
          me.appointmentId = apptData.id;
          me.appointmentTime = apptData.start_time;

          servs = me.appointmentData.services;

          for (var i = 0, len = servs.length; i < len; i += 1) {
            servObj = servs[i];
            me.servicesData.push({
              serviceId: servObj.id,
              serviceDuration: servObj.total_duration,
              serviceName: servObj.name
            });

            me.serviceIds.push(servObj.id);
          }

          me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
            me.counterData = data;
            hasCounter = true;
            runUpdate();
          });
        }, function () { // If there is an error retrieving appointment id, go to beginning of APP
          var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

          window.location = myUrl;
        });
      } else {
        if (me.counterId !== data.params.counterId) {
          me.calendarId = '0';
        }
        if (data.params.updateMode) {
          me.updateMode = true;
          me.calendarId = '0';
        } else {
          me.updateMode = false;
        }
        me.counterId = data.params.counterId;
        me.servicesData = data.params.services;
        for (var i = 0, len = me.servicesData.length; i < len; i += 1) {
          me.serviceIds.push(me.servicesData[i].serviceId);
        }

        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildServices = function () {
    var myTmpl, sData,
      me = this;

    this.servContainer.find('.service').remove();
    for (var i = 0, len = this.servicesData.length; i < len; i += 1) {
      sData = this.servicesData[i];
      myTmpl = this.serviceTmpl.clone();
      this.servContainer.append(myTmpl);

      if (site.client.isMobile) {
        myTmpl.find('.service-head').text(sData.serviceName + ' (' + sData.serviceDuration + ' ' + this.minLabel + ')');
      } else {
        myTmpl.find('.service-head').text(sData.serviceName);
        myTmpl.find('.selection-time').text(sData.serviceDuration + ' ' + this.minLabel);
      }

      this.totalTime += parseInt(sData.serviceDuration);
      // this.serviceIds.push(sData.serviceId);

      function changeServSel(e) {
        e.preventDefault();

        var upObj = {
          sectionId: 'services',
          params: {
            sectionId: me.id,
            counterId: me.counterId,
            updateMode: me.updateMode
          }
        };

        me.model.update(upObj);
      }

      this.changeServices.off('click');
      this.changeServices.click(changeServSel);
      this.backTo.off('click');
      this.backTo.click(changeServSel);
    }

    if (!site.client.isMobile && this.servicesData.length > 1) {
      apptBook.equalHeights(this.servContainer.find('.service-head'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildLocation = function () {
    var me = this;

    this.locSelect.find('option').remove();
    this.stores = {};
    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var storeName = this.countersData[i].name,
        optionText = this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1,
        optionValue = this.countersData[i].id,
        newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
        storeNum = this.countersData[i].store_no;

      this.stores[optionValue] = {
        store: storeNum,
        name: storeName
      };

      if (optionValue === this.counterId) {
        newOption.attr('selected', 'selected');
      }
      this.locSelect.append(newOption);
      /* if (this.countersData[i].service_ids.length > 0 && this.countersData[i].calendars.length > 0) {
        this.locSelect.append(newOption);
      }*/
    }

    site.util.refreshSelectBoxes(me.container.find('.selectbox'));

    function onLocChange(e) {
      var counterId = this.value,
        upObj = {
          sectionId: 'appointments',
          params: {
            counterId: counterId,
            services: me.servicesData,
            updateMode: me.updateMode
          }
        };

      if (counterId !== me.counterId) {
        me.model.update(upObj);

        site.track.evtLink({
          event_name: 'appointmentBooking_reselectLocation',
          event_category: 'appointment booking',
          event_action: 'reselect location',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });
      }
    }
    this.locSelect.off('change'); // remove this first just in case we have already been to this screen
    this.locSelect.on('change', onLocChange);
  };

  apptBook.AppointmentSelectSection.prototype.buildArtists = function () {
    var me = this,
      calData = this.counterData.calendars;

    // this.artContainer.css('display','block');
    this.artContainer.show();
    this.artSelect.find('option').remove();
    if (!calData || !calData.length) {
      this.launchSelErrOverlay();
      // this.artContainer.css('display','none');
      this.artContainer.hide();
    } else if (calData.length <= 1) {
      this.artContainer.hide();
    } else {
      for (var i = 0, len = calData.length; i < len; i += 1) {
        if (calData[i].public_name === 'Any' && this.artAnyValue) {
          calData[i].public_name = this.artAnyValue;
        }
        var optionText = calData[i].public_name,
          optionValue = calData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>');

        if (optionValue === this.calendarId) {
          newOption.attr('selected', 'selected');
        }

        this.artSelect.append(newOption);
      }

      site.util.refreshSelectBoxes(me.container.find('.selectbox'));
    }
  };

  apptBook.AppointmentSelectSection.prototype.buildApptSelect = function () {
    var mOptions, vOptions, dpOptions, calDate, calTable, calHead, cHCont, colHeads, timeSlotsContainer,
      timeSlotRow, monthNames, dayNames, slotLabels, dpTrigger, dpField, dpOverlay, dpCalCont, dpCloseBtn, dp, dpMonthNames,
      dpDayNames, CalHeadView, CalTimeSlotsView, CalDatePicker, dpYearSuffix,
      me = this;

    if (site.client.isMobile) {
      timeSlotsContainer = this.apptContainer.find('table.day');
      calHead = this.apptContainer.find('.calendar-head');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      slotLabels = timeSlotsContainer.attr('data-time-slots').split(',');
      dp = this.apptContainer.find('.date-picker');
      dpField = this.apptContainer.find('#appt-book-date-picker-field');
      dpCalCont = this.apptContainer.find('#appt-book-datepicker-calendar-container');
      dpMonthNames = dp.attr('data-months').split(',');
      dpDayNames = dp.attr('data-days').split(',');
      dpYearSuffix = dp.attr('data-year-suffix');
      CalHeadView = apptBook.CalendarHeaderMobile;
      CalTimeSlotsView = apptBook.CalendarTimeSlotsMobile;
      CalDatePicker = apptBook.CalDatePickerMobile;

      vOptions = {
        container: this.apptContainer,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels
      };

      dpOptions = {
        calContainer: dpCalCont,
        datepickerField: dpField,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        yearSuffix: dpYearSuffix
      };
    } else {
      calTable = this.apptContainer.find('.weekdays');
      calHead = this.apptContainer.find('.calendar-head');
      cHCont = calTable.find('thead.col-heads');
      colHeads = cHCont.find('th');
      timeSlotsContainer = calTable.find('tbody.timeslots');
      timeSlotRow = timeSlotsContainer.find('tr').remove().first();
      monthNames = cHCont.attr('data-months').split(',');
      dayNames = cHCont.attr('data-days').split(',');
      slotLabels = cHCont.attr('data-time-slots').split(',');
      dpTrigger = calHead.find('#appt-book-date-picker-trigger');
      dpField = calHead.find('#appt-book-date-picker-field');
      dpOverlay = this.container.find('#appt-book-datepicker-overlay').remove();
      dpCalCont = dpOverlay.find('#appt-book-datepicker-calendar-container');
      dpCloseBtn = dpOverlay.find('.overlay-close');
      dpMonthNames = dpTrigger.attr('data-months').split(',');
      dpDayNames = dpTrigger.attr('data-days').split(',');
      dpYearSuffix = calHead.attr('data-year-suffix');
      /* dpMonthNames = calHead.attr('data-months').split(',');
      dpDayNames = dayNames;*/
      CalHeadView = apptBook.CalendarHeader;
      CalTimeSlotsView = apptBook.CalendarTimeSlots;
      CalDatePicker = apptBook.CalDatePicker;

      vOptions = {
        container: this.apptContainer,
        colHeads: colHeads,
        timeSlotsContainer: timeSlotsContainer,
        timeSlotRow: timeSlotRow,
        monthNames: monthNames,
        dayNames: dayNames,
        slotLabels: slotLabels
      };

      dpOptions = {
        overlay: dpOverlay,
        closeBtn: dpCloseBtn,
        calContainer: dpCalCont,
        weekContainer: calHead,
        datepickerField: dpField,
        datepickerTrigger: dpTrigger,
        monthNames: dpMonthNames,
        dayNames: dpDayNames,
        yearSuffix: dpYearSuffix,
        jqBod: this.jqBod
      };
    }

    mOptions = {
      dataModel: this.model,
      launchOverlayCallback: this.launchSelErrOverlay.bind(this),
      counterId: this.counterId,
      appointmentDuration: this.totalTime,
      serviceIds: this.serviceIds
    };

    this.calModel = new apptBook.CalendarModel();
    this.calModel.setData(mOptions);
    this.calTimeSlots = new CalTimeSlotsView(vOptions);
    this.calHeadView = new CalHeadView(calHead);
    this.calTimeSlots.setModel(this.calModel).startObserving();
    this.calHeadView.setModel(this.calModel).startObserving();

    this.datePicker = new CalDatePicker(dpOptions);
    this.datePicker.setModel(this.calModel);

    this.artSelect.on('change', function (e) {
      var calId = this.value,
        calName = this.options[this.selectedIndex].text;

      if (calId !== me.calendarId) {
        me.calModel.update({ calendarId: calId });
        me.calendarId = calId;
      }
    });

    calDate = this.appointmentTime ? this.calTimeSlots.convertTimeString(this.appointmentTime) : new Date();

    this.calModel.update({
      date: calDate,
      hilite: true,
      calendarId: this.calendarId,
      appointmentTime: this.appointmentTime
    });
  };

  apptBook.AppointmentSelectSection.prototype.buildBookAppt = function () {
    var totText, area_code,
      me = this,
      signIn = this.signInContainer.find('#appt-book-sign-in-form-container'),
      signInLink = this.signInContainer.find('#appt-book-sign-in-link').off('click'),
      forgotPassword = this.signInContainer.find('.js-forgot-password'),
      loginEmail = this.signInContainer.find('#appt-book-login-email'),
      pw = this.signInContainer.find('#appt-book-login-password'),
      signInBtn = signIn.find('#appt-book-login-submit').off('click'),
      fbsignInBtn = signIn.find('#appt-book-fblogin-submit').off('click'),
      fbOverlay = signIn.find('.js-fb-disclaimer-error'),
      bookBtn = this.confContainer.find('#appt-book-book-submit').off('click'),
      fNameInput = this.bookContainer.find('.appt-book-first-name'),
      lNameInput = this.bookContainer.find('.appt-book-last-name'),
      emailInput = this.bookContainer.find('.appt-book-email'),
      phoneInput = this.bookContainer.find('.appt-book-mobile'),
      krFormat = this.bookContainer.find('#js_appt_use_kr_mobile_number_fields'),
      commentsInput = this.bookContainer.find('.appt-book-note'),
      signUpEmailInput = this.bookContainer.find('.registration__email-list').find('input'),
      signUpSMSInput = this.bookContainer.find('.registration__sms-list').find('input'),
      signUpApptSMSNotificationsEnabledInput = this.bookContainer.find('.enable_sms_notifications').find('input'),
      errorContainer = this.container.find('#appt-book-confirm-error-messages'),
      errorMessages = errorContainer.find('.error-message'),
      termsPrivacyRadio = this.bookContainer.find('.appt-book-oab-legal-privacy'),
      smsBookingConfirmationRadio = this.bookContainer.find('.appt-book-oab-sms-confirmation'),
      termsEmailPromotionsRadio = this.bookContainer.find('.appt-book-oab-email-promotions'),
      termsSMSPromotionsRadio = this.bookContainer.find('.appt-book-oab-sms-notification'),
      termsPostalRadio = this.bookContainer.find('.appt-book-oab-postal'),
      termsThirdPartyPromotionRadio = this.bookContainer.find('.appt-book-third-party'),
      termsPrivacyRadioLabel = this.bookContainer.find('.accept-terms-head'),
      smsBookingConfirmationRadioLabel = this.bookContainer.find('.accept-sms-confirmation-head'),
      termsEmailPromotionsRadioLabel = this.bookContainer.find('.accept-email-head'),
      termsSMSPromotionsRadioLabel = this.bookContainer.find('.accept-sms-head'),
      termsPostalRadioLabel = this.bookContainer.find('.accept-postal-head'),
      termsThirdPartyPromotionRadioLabel = this.bookContainer.find('.accept-thirdparty-head'),
      countryCode = this.bookContainer.find('#js_country_code'),
      drupal = Drupal || {},
      settings = drupal.settings || {};

    termsCheckbox = this.bookContainer.find('.appt-book-terms'),
    privacyCheckbox = this.bookContainer.find('.appt-book-oab-email-promotions'),
    termsCheckboxLabel = this.bookContainer.find('.registration__terms'),
    privacyCheckboxLabel = this.bookContainer.find('.registration__oab-email-promotions'),
    mobilePrefixInput = this.bookContainer.find('input[name="mobile-prefix"]');
    var apptUseKRMobileNumberFields = parseInt(krFormat.text());

    if (apptUseKRMobileNumberFields) {
      phone1Input = this.bookContainer.find('.js_appt_mobile_part1');
      phone2Input = this.bookContainer.find('.js_appt_mobile_part2');
      apptKRPhoneCode = this.bookContainer.find('.js_appt_kr_phone_code');
      var apptPhoneCode = this.bookContainer.find('#js_appt_phone_codes');

      apptPhoneCode = apptPhoneCode.text();
      apptKrSelectPhoneCode = this.bookContainer.find('select.js_appt_kr_phone_code');
      var apptPhoneCodeSplit = apptPhoneCode.split(',');
      var codeOptions;

      $.each(apptPhoneCodeSplit, function (i, val) {
        codeOptions = $('<option></option>', {
          value: val,
          text: val
        });
        apptKRPhoneCode.append(codeOptions);
      });
      phoneInput.keydown(function (e) {
        var key = e.charCode || e.keyCode || 0;

        return key === 8 || key === 9 || key === 46 || (key >= 48 && key <= 57) || (key >= 96 && key <= 105);
      });
    }

    if (settings.fb_login_app_id && site.facebook) {
      site.facebook.init();
    }

    this.startOver.off('click');
    this.startOver.click(function () {
    });

    loginEmail.val('');
    pw.val('');
    fNameInput.val('').removeAttr('disabled');
    lNameInput.val('').removeAttr('disabled');
    emailInput.val('').removeAttr('disabled');
    phoneInput.val('').removeAttr('disabled');
    commentsInput.val('');
    this.totalElem.empty();

    if (this.userData && this.userData.signed_in) {
      this.signInContainer.css('display', 'none');

      if (this.userData.first_name) {
        fNameInput.val(this.userData.first_name).attr('disabled', 'disabled');
      }

      if (this.userData.last_name) {
        lNameInput.val(this.userData.last_name).attr('disabled', 'disabled');
      }

      emailInput.val(this.userData.email_address).attr('disabled', 'disabled');

      if (this.userData.mobile_phone) {
        phoneInput.val(this.userData.mobile_phone).attr('disabled', 'disabled');
      }

      if (site.client.isMobile) {
        if (this.userData.mobile_email_optin || this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      } else {
        if (this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      }

      if (this.userData.sms_optin) {
        signUpSMSInput.attr('checked', 'checked');
      } else {
        signUpSMSInput.removeAttr('checked');
      }
    } else {
      this.signInContainer.css('display', 'block');
    }

    totText = this.totalText + ' ' + this.totalTime + ' ' + this.minLabel;
    this.totalElem.html(totText);

    this.calModel.on('time_selected', function (data) {
      bookBtn.removeClass('disabled');
    });

    this.calModel.on('time_deselected', function (data) {
      bookBtn.addClass('disabled');
    });

    $.each(['show', 'hide'], function (i, ev) {
      var el = $.fn[ev];

      $.fn[ev] = function () {
        this.trigger(ev);

        return el.apply(this, arguments);
      };
    });

    $('body').on('show', fbOverlay, function () {
      signIn.css('height', 'auto');
    });

    signInLink.click(function (e) {
      e.preventDefault();
      var h;

      $(this).css('display', 'none');
      signIn.css('display', 'block');
      signIn.css('height', 'auto');
      h = signIn.height();
      signIn.height(0);
      signIn.animate({ height: h }, 1000, function () {
        setSignIn();
      });
    });
    window.fbsignInBtn = fbsignInBtn;

    forgotPassword.click(function (e) {
      e.preventDefault();
      if (!loginEmail.val()) {
        return null;
      }
      site.signin.requestPassword(loginEmail.val());
    });

    function setSignIn() {
      fbsignInBtn.click(function () {
        var token = null,
          $this = $(this),
          params = [],
          lastSource = null,
          pcEmailPromotions = 0,
          $optInFormInput = $('#form--facebook_signin--field--PC_EMAIL_PROMOTIONS');

        if ($this.hasClass('disabled')) {
          return;
        }

        lastSource = 'appointment_booking';
        pcEmailPromotions = $optInFormInput.is(':checked') ? 1 : 0;

        if (typeof FB === 'object') {
          FB.getLoginStatus(function (response) {
            statusChangeCallback(response);
          });
        }

        function statusChangeCallback(response) {
          if (FB.getAuthResponse()) {
            token = response.authResponse.accessToken;
            rpccall();
          }
        }

        function rpccall() {
          $this.addClass('disabled');
          params.push({
            _SUBMIT: 'facebook_signin',
            token: token,
            LAST_SOURCE: lastSource,
            PC_EMAIL_PROMOTIONS: pcEmailPromotions
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              var h,
                rData = jsonRpcResponse.getData().userinfo;

              me.model.updateAuthToken(function () {
                $this.removeClass('disabled');
                emailInput.val(rData.email_address).attr('disabled', 'disabled');

                if (rData.first_name) {
                  fNameInput.val(rData.first_name);
                  fNameInput.attr('disabled', 'disabled');
                }
                if (rData.last_name) {
                  lNameInput.val(rData.last_name);
                  lNameInput.attr('disabled', 'disabled');
                }
                if (rData.mobile_number) {
                  phoneInput.val(rData.mobile_number);
                  phoneInput.attr('disabled', 'disabled');
                }
                if (site.client.isMobile) {
                  if (rData.mobile_email_optin) {
                    signUpEmailInput.attr('checked', 'checked');
                  } else {
                    signUpEmailInput.removeAttr('checked');
                  }
                } else {
                  if (rData.pc_email_optin) {
                    signUpEmailInput.attr('checked', 'checked');
                  } else {
                    signUpEmailInput.removeAttr('checked');
                  }
                }
                if (rData.sms_optin) {
                  signUpSMSInput.attr('checked', 'checked');
                } else {
                  signUpSMSInput.removeAttr('checked');
                }

                fNameInput.focus();

                me.userData = rData;
              });

              errorContainer.css('display', 'none');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              $this.removeClass('disabled');

              signInLink.css('display', 'inline-block');

              h = signIn.css('height');
              signIn.animate({ height: 0 }, 1000, function () {
                signIn.css('display', 'none');
                signIn.height(h);
                me.signInContainer.css('display', 'none');
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              var errorLookupFunc = {
                errorRequiredPassword: function () {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                },
                errorRequiredLoginId: function () {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                },
                errorSignInNoAccount: function () {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                },
                errorAccountLock: function () {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                },
                errorFacebookLogin: function (myErr) {
                  errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                }
              };
              var errorLookup = {
                'required.password.signin': {
                  showError: errorLookupFunc.errorRequiredPassword
                },
                'invalid.password.signin': {
                  showError: errorLookupFunc.errorRequiredPassword
                },
                'required_or.email_address.device_id.required_or.signin': {
                  showError: errorLookupFunc.errorRequiredLoginId
                },
                'invalid.email_address.signin': {
                  showError: errorLookupFunc.errorRequiredLoginId
                },
                'no_account..signin': {
                  showError: errorLookupFunc.errorSignInNoAccount
                },
                'social_fb_no_email': {
                  showError: errorLookupFunc.errorFacebookLogin
                },
                'social_duplicate_account_links': {
                  showError: errorLookupFunc.errorFacebookLogin
                }
              };

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key && errorLookup[myErr.key]) {
                  errorLookup[myErr.key].showError(myErr);
                }
              }
              $this.removeClass('disabled');
            }
          });
        }
      });
      signInBtn.click(function (e) {
        e.preventDefault();
        var $this = $(this),
          params = [];

        if ($this.hasClass('disabled')) {
          return;
        }

        $this.addClass('disabled');
        params.push({
          _SUBMIT: 'signin',
          EMAIL_ADDRESS: loginEmail.val(),
          PASSWORD: pw.val()
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(params),
          onSuccess: function (jsonRpcResponse) {
            var h,
              rData = jsonRpcResponse.getData().userinfo;

            me.model.updateAuthToken(function () {
              $this.removeClass('disabled');
              emailInput.val(rData.email_address).attr('disabled', 'disabled');

              if (rData.first_name) {
                fNameInput.val(rData.first_name);
                fNameInput.attr('disabled', 'disabled');
              }
              if (rData.last_name) {
                lNameInput.val(rData.last_name);
                lNameInput.attr('disabled', 'disabled');
              }
              if (rData.mobile_number) {
                phoneInput.val(rData.mobile_number);
                phoneInput.attr('disabled', 'disabled');
              }

              if (site.client.isMobile) {
                if (rData.mobile_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              } else {
                if (rData.pc_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              }

              if (rData.sms_optin) {
                signUpSMSInput.attr('checked', 'checked');
              } else {
                signUpSMSInput.removeAttr('checked');
              }

              fNameInput.focus();

              me.userData = rData;
            });

            errorContainer.css('display', 'none');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            $this.removeClass('disabled');

            signInLink.css('display', 'inline-block');

            h = signIn.css('height');
            signIn.animate({ height: 0 }, 1000, function () {
              signIn.css('display', 'none');
              signIn.height(h);
              me.signInContainer.css('display', 'none');
            });
          },
          onFailure: function (jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];

              if (myErr && myErr.key) {
                if (oab_error_password_required) {
                  if (myErr.key === 'required.password.signin') {
                    pw.addClass('error');
                    errorMessages.filter('#error-required-password').css('display', 'block');
                  }
                } else {
                  if (myErr.key === 'required.password.signin') {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-password').css('display', 'block');
                  }
                }
                if (oab_email_required_err_msg) {
                  if (myErr.key === 'required.email_address.signin') {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }
                }
                if (myErr.key === 'format.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                }
                if (myErr.key === 'invalid.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (myErr.key === 'required_or.email_address.device_id.required_or.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'invalid.email_address.signin') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'no_account..signin') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                }
              }
            }

            $this.removeClass('disabled');
          }
        });
      });
    }

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        signUpEmailParams = [],
        signUpEmailObj = {},
        fName = fNameInput.val(),
        lName = lNameInput.val(),
        email = emailInput.val(),
        phone = phoneInput.val(),
        terms = termsCheckbox.is(':checked') ? 1 : 0,
        oab_email_promotions = privacyCheckbox.is(':checked') ? 400 : 0,
        signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
        signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
        enableApptSMS = signUpApptSMSNotificationsEnabledInput.is(':checked') ? signUpApptSMSNotificationsEnabledInput.val() : 0,
        oabTermsEmailPromotionsRadio = termsEmailPromotionsRadio.is(':checked') ? $('input[name=PC_EMAIL_PROMOTIONS]:checked').val() : 0,
        oabTermsSMSConfirmationRadio = smsBookingConfirmationRadio.is(':checked') ? $('input[name=APPT_SMS_NOTIFICATIONS]:checked').val() : 0,
        oabTermsSMSPromotionsRadio = termsSMSPromotionsRadio.is(':checked') ? $('input[name=SMS_PROMOTIONS]:checked').val() : 0,
        oabTermsPostalRadio = termsPostalRadio.is(':checked') ? $('input[name=POSTAL_PROMOTIONS]:checked').val() : 0,
        oabTermsThirdPartyPromotionRadio = termsThirdPartyPromotionRadio.is(':checked') ? $('input[name=ACCEPTED_THIRD_PARTY]:checked').val() : 0,
        signUpEmailDone = false,
        signUpSMSDone = false,
        comments = commentsInput.val(),
        $this = $(this),
        mobilePrefix = mobilePrefixInput.val(),
        isEmptyField = 0;

      isArray = me.serviceIds instanceof Array;

      if ($this.hasClass('disabled')) {
        return;
      }
      errorContainer.css('display', 'block');
      errorMessages.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle, label').removeClass('error');
      emptyInputs();
      if (isEmptyField) {
        $this.removeClass('disabled');

        return;
      }
      $this.addClass('disabled');

      params = {
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        start_time: me.calModel.getSelection().selectionString,
        customer_first_name: fName,
        customer_last_name: lName,
        customer_email: email
      };

      site.track.evtLink({
        event_name: 'appointmentBooking_DateTime',
        event_category: 'appointment booking',
        event_action: 'Date and Time Picked',
        event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
      });

      site.track.evtLink({
        event_name: 'appointmentBooking_bookNow',
        event_category: 'appointment booking',
        event_action: 'bookNow',
        event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + params.start_time
      });
      if (enableApptSMS || oab_send_sms_default) {
        params.sms_notifications_enabled = 1;
      }

      if (comments) {
        params.customer_comments = comments;
      }

      if (phone) {
        if (apptUseKRMobileNumberFields) {
          area_code = apptKrSelectPhoneCode.val();
          if (area_code) {
            area_code = area_code.substr(1, 2);
          }
          params.customer_phone = countryCode.text() + area_code + phone1Input.val() + phone2Input.val();
        } else {
          params.customer_phone = phone;
        }
      }
      function emptyInputs() {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var phone_maxlength = phoneInput.attr('maxlength');
        var phone_regex = new RegExp(phoneInput.attr('pattern'));
        var phone_prefix_regex = new RegExp(mobilePrefixInput.attr('pattern'));
        var phone1_regex, phone2_regex;

        if (apptUseKRMobileNumberFields) {
          phone1_regex = new RegExp(phone1Input.attr('pattern'));
          phone2_regex = new RegExp(phone2Input.attr('pattern'));
          var phone_full_length = phone1Input.val() + phone2Input.val();
          var phone_zero_length_regex = /^(?!0+$)\d{7,8}$/;
        }
        if (!fNameInput.val()) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!$(lNameInput.parent()).hasClass('js-no-last-name') && !lNameInput.val()) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!emailInput.val() || !testEmail.test(emailInput.val())) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          isEmptyField = 1;
        }
        if (termsCheckbox.val() && !termsCheckbox.is(':checked')) {
          errorMessages.filter('#error-terms').css('display', 'block');
          termsCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (privacyCheckbox.val() && !privacyCheckbox.is(':checked')) {
          errorMessages.filter('#error-oab-email-promotions').css('display', 'block');
          privacyCheckboxLabel.addClass('error');
          isEmptyField = 1;
        }
        if (jsconfig_settings.oab_legal_statement) {
          if (!termsPrivacyRadio.is(':checked')) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else if (termsPrivacyRadio.is(':checked') && $('input[name=ACCEPTED_PRIVACY_POLICY]:checked').val() === '0') {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPrivacyRadioLabel.removeClass('error');
          }
          if (!smsBookingConfirmationRadio.is(':checked')) {
            errorMessages.filter('#error-oab-sms-confirmation').css('display', 'block');
            smsBookingConfirmationRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            smsBookingConfirmationRadioLabel.removeClass('error');
          }
          if (!termsEmailPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsEmailPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsEmailPromotionsRadioLabel.removeClass('error');
          }
          if (!termsSMSPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsSMSPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsSMSPromotionsRadioLabel.removeClass('error');
          }
          if (!termsPostalRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsPostalRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPostalRadioLabel.removeClass('error');
          }
          if (!termsThirdPartyPromotionRadio.is(':checked')) {
            errorMessages.filter('#error-oab-third-party-promotions').css('display', 'block');
            termsThirdPartyPromotionRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsThirdPartyPromotionRadioLabel.removeClass('error');
          }
        }
        if (apptUseKRMobileNumberFields) {
          if (phone_full_length && !phone_zero_length_regex.test(phone_full_length)) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (!apptKrSelectPhoneCode.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          } else {
            apptKRPhoneCode.removeClass('error');
          }
          if (phone1Input.val()) {
            if (phone1_regex && !phone1_regex.test(phone1Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part1_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone1Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (phone2Input.val()) {
            if (phone2_regex && !phone2_regex.test(phone2Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part2_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone2Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
        } else {
          if (!phoneInput.val()) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
            isEmptyField = 1;
          } else if (phone_regex && !phone_regex.test(phone)) {
            phoneInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
            isEmptyField = 1;
          }
        }
        if (Drupal.settings.enable_mobile_prefix_validation) {
          if (!mobilePrefixInput.val()) {
            errorMessages.filter('#error-book-phone-prefix').css('display', 'block');
            mobilePrefixInput.addClass('error');
            isEmptyField = 1;
          } else if (phone_prefix_regex && !phone_prefix_regex.test(mobilePrefix)) {
            mobilePrefixInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-book-phone-prefix-invalid').css('display', 'block');
            isEmptyField = 1;
          }
        }
      }
      function onBookSuccess(r) {
        var updateData,
          apptId = r.id;

        site.track.evtView({
          page_url: '/book-appointment/complete',
          location: location.origin + '/book-appointment/complete',
          page_name: 'Book Appointment - Complete'
        });

        site.track.evtLink({
          event_name: 'appointmentBooking_complete',
          event_category: 'appointment booking',
          event_action: 'appointment booked',
          event_label: r.counter.store_no + ' - ' + r.counter.name + ' - ' + r.start_time
        });

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        $this.addClass('disabled');
        errorMessages.css('display', 'none');
        errorContainer.css('display', 'none');
        me.container.find('input').removeClass('error');
        me.container.find('textarea').removeClass('error');
        me.container.find('label').removeClass('error');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        var errFName = r.customer_first_name,
          errLName = r.customer_last_name,
          errEmail = r.customer_email,
          errPhone = r.customer_phone,
          errComments = r.customer_comments;

        errorContainer.css('display', 'block');
        errorMessages.css('display', 'none');

        if (r.code === 500 || r.code === '500') {
          me.launchBookConflictOverlay();

          return;
        }

        if (errFName && errFName.length) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
        }
        if (errLName && errLName.length) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
        }
        if (errEmail && errEmail.length) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
        }
        if (errPhone && errPhone.length) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
        }
        if (errComments && errComments.length) {
          errorMessages.filter('#error-book-comments').css('display', 'block');
          commentsInput.addClass('error');
        }
      }

      function doBooking() {
        errorMessages.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle, label').removeClass('error');
        if (isEmptyField) {
          $this.removeClass('disabled');
        } else if (me.updateMode && me.appointmentId) {
          me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        } else {
          me.model.bookAppointment(params, onBookSuccess, onBookError);
        }
      }

      signUpEmailObj._SUBMIT = 'email_signup';
      signUpEmailObj.EMAIL_ADDRESS = email;
      signUpEmailObj.PC_EMAIL_ADDRESS = email;
      signUpEmailObj.LAST_SOURCE = 'appointment_booking_reg';
      if (!signUpEmail) {
        if (!jsconfig_settings.oab_legal_statement) {
          signUpEmailObj.ACTION = 'unset';
        } else {
          signUpEmailObj.ACTION = '';
        }
      }
      if (jsconfig_settings.oab_legal_statement) {
        signUpEmailObj.LAST_SOURCE = 'appointment_booking';
        signUpEmailObj.ORIGINAL_SOURCE = 'appointment_booking';
        signUpEmailObj.suppress_conf_email = 1;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = 1;
        if (oabTermsThirdPartyPromotionRadio === '1') {
          signUpEmailObj.PC_EMAIL_PROMOTIONS = oabTermsEmailPromotionsRadio;
          if (oabTermsSMSPromotionsRadio === '1' || oabTermsSMSConfirmationRadio === '1') {
            signUpEmailObj.MOBILE_NUMBER = apptKrSelectPhoneCode.val() + '-' + phone1Input.val() + '-' + phone2Input.val();
          }
          signUpEmailObj.SMS_PROMOTIONS = oabTermsSMSPromotionsRadio;
          signUpEmailObj.POSTAL_PROMOTIONS = oabTermsPostalRadio;
          signUpEmailObj.ACCEPTED_THIRD_PARTY = oabTermsThirdPartyPromotionRadio;
        } else {
          signUpEmailObj.ACTION = 'unset';
          signUpEmailObj.PC_EMAIL_PROMOTIONS = '0';
          signUpEmailObj.SMS_PROMOTIONS = '0';
          signUpEmailObj.POSTAL_PROMOTIONS = '0';
          signUpEmailObj.ACCEPTED_THIRD_PARTY = '0';
        }
      }
      if (!jsconfig_settings.do_not_submit_sms_pg_form) {
        if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
          signUpEmailObj._SECONDARY_SUBMIT = 'sms';
          signUpEmailObj.MOBILE_PHONE = phone;
          signUpEmailObj.SMS_PROMOTIONS = 1;
        }

        if (!signUpSMS) {
          signUpEmailObj._SECONDARY_SUBMIT = 'sms';
          signUpEmailObj.SMS_PROMOTIONS = 0;
        }
      }
      var settings = Drupal.settings || {};
      var oab = settings.oab || {};
      var oab_params = oab.oab_params || 0;

      if (oab_params) {
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = terms;
        signUpEmailObj.OAB_EMAIL_PROMOTIONS = oab_email_promotions;
      }

      signUpEmailParams.push(signUpEmailObj);

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: JSON.stringify(signUpEmailParams),
        onSuccess: function (jsonRpcResponse) {
          signUpEmailDone = true;
          doBooking();
        },
        onFailure: function (jsonRpcResponse) {
          var errObjs = jsonRpcResponse.getMessages();

          errorContainer.css('display', 'block');
          errorMessages.css('display', 'none');

          for (var i = 0; i < errObjs.length; i += 1) {
            var myErr = errObjs[i];

            if (myErr && myErr.key) {
              if (myErr.key === 'required.pc_email_address.email_signup' || myErr.key === 'invalid.pc_email_address.email_signup') {
                emailInput.addClass('error');
                errorMessages.filter('#error-signup-email').css('display', 'block');
              }

              if (myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms').css('display', 'block');
              }

              if (myErr.key === 'invalid.mobile_phone.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
              }
            }
          }

          if (!fNameInput.val()) {
            errorMessages.filter('#error-book-first-name').css('display', 'block');
            fNameInput.addClass('error');
          }
          if (!lNameInput.val()) {
            errorMessages.filter('#error-book-last-name').css('display', 'block');
            lNameInput.addClass('error');
          }
          if (!termsCheckbox.is(':checked')) {
            errorMessages.filter('#error-terms').css('display', 'block');
          }
          if (!privacyCheckbox.is(':checked')) {
            errorMessages.filter('#error-oab-email-promotions').css('display', 'block');
          }
          $this.removeClass('disabled');
        }
      });
    }
  };

  apptBook.AppointmentSelectSection.prototype.launchSelErrOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.selErrOverlay);
    this.selErrOverlay.show();
    this.selErrOverlay.off('click');
    this.selErrOverlay.click(function (e) {
      e.preventDefault();
      var upObj = {
        sectionId: 'previous',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          updateMode: me.updateMode
        }
      };

      me.model.update(upObj);
      me.selErrOverlay.off('click');
      me.selErrOverlay.remove();
    });
  };

  apptBook.AppointmentSelectSection.prototype.launchBookConflictOverlay = function () {
    var me = this,
      selDate = this.calModel.getSelection().selectionDate;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.calModel.update({ date: selDate });
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.click(function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  /* *
   *
   * Appointments Time Slot Selector Calendar and Mobile Calendar
   * This is a set of Classes that create objects that are the members of an MVC Calendar that displays and allows
   * selection of the available time slots of calendars coming from the API.
   *
   *
   *
   * */

  /**
   * CalendarModel
   * This is the model. It controls the calendars state and main logic.
   * It broadcasts updates to registered views and controllers
   *
   */

  apptBook.CalendarModel = function () {
    apptBook.CalendarModel.superclass.constructor.call(this);
    this.dataSet = false;
  };

  // CalendarModel is a Publisher in a Publisher Subscriber (event listening) pattern.
  ctrlopt.extend(apptBook.CalendarModel, ctrlopt.Publisher);

  apptBook.CalendarModel.prototype.setData = function (options) {
    if (this.dataSet) {
      return;
    }
    this.dataSet = true;
    this.calData = {};
    this.dataModel = options.dataModel;
    this.launchOverlay = options.launchOverlayCallback;
    this.counterId = options.counterId;
    this.calendarId = 0;
    this.apptDur = options.appointmentDuration;
    this.serviceIds = options.serviceIds;
  };

  apptBook.CalendarModel.prototype.update = function (data) {
    if (!this.dataSet || !data) {
      return;
    }
    var me = this;

    this.calData.hilite = data.hilite ? true : false;
    this.calData.apptDur = this.apptDur;
    this.calData.currentDate = new Date();
    this.calData.myDate = data.date || this.calData.myDate || this.calData.currentDate;
    this.calendarId = data.calendarId || this.calendarId;
    this.counterId = data.counterId || this.counterId;
    this.serviceIds = data.serviceIds || this.serviceIds;
    this.calData.apptTime = data.appointmentTime;

    this.dataModel.getCounter(this.counterId, { service_id: this.serviceIds }, function (countData) {
      var cal,
        cals = countData.calendars;

      if (!cals || !cals.length) {
        me.calData.timeslots = null;
        if (me.launchOverlay && typeof me.launchOverlay === 'function') {
          me.launchOverlay();
        }
      } else {
        for (var i = 0, len = cals.length; i < len; i += 1) {
          cal = cals[i];
          if (parseInt(cal.id, 10) === parseInt(me.calendarId, 10)) {
            me.calData.timeslots = cal.timeslots;
            break;
          }
        }
      }

      me.fire('time_deselected');
      me.dispatchUpdate(me.calData);
    });
  };

  apptBook.CalendarModel.prototype.dispatchUpdate = function (data) {
    this.fire('update', data);
  };

  apptBook.CalendarModel.prototype.getData = function () {
    return this.dataSet ? this.calData : null;
  };

  apptBook.CalendarModel.prototype.setSelection = function (selection) {
    this.selection = selection;
    this.selectionString = selection.getFullYear() + '-' + (selection.getMonth() + 1).toString().padStart(2, '0') + '-' + selection.getDate().toString().padStart(2, '0') + ' ' + selection.getHours().toString().padStart(2, '0') + ':' + ('0' + selection.getMinutes()).slice(-2) + ':00';

    this.fire('time_selected', this.selectionString);
  };

  apptBook.CalendarModel.prototype.getSelection = function () {
    return {
      selectionDate: this.selection,
      selectionString: this.selectionString
    };
  };

  /**
   * CalendarHeader is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeader = function (header) {
    apptBook.CalendarHeader.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.rArrow = this.header.find('.next');
    this.lArrow = this.header.find('.previous');
    this.headContent = this.header.find('.cal-copy');
    this.headCopy = this.headContent.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeader, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeader.prototype.defaultController = function () {
    return this.controller;
  };

  apptBook.CalendarHeader.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay()),
      now = new Date(),
      nowDay = startDayShift(now.getDay());

    now.setDate(now.getDate() - nowDay);

    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0);

    if (this.firstDay > now) {
      this.lArrow.css('visibility', 'visible');
    } else {
      this.lArrow.css('visibility', 'hidden');
    }

    if (oab_show_year_text_at_last) {
      headOut = this.firstDay.getDate() + ' ' + this.months[this.firstDay.getMonth()] + ' ' + this.headCopy + ' ' + this.firstDay.getFullYear();
    } else if (oab_date_override) {
      headOut = this.headCopy + ' ' + this.firstDay.getDate() + oab_date_month_separator + this.months[this.firstDay.getMonth()] + ', ' + this.firstDay.getFullYear();
    } else if (oab_date_format) {
      headOut = this.firstDay.getFullYear() + ' ' + this.header.attr('data-year-suffix') + ' ' + (this.firstDay.getMonth() + 1) + ' ' + this.header.attr('data-month-suffix') + ' ' + this.firstDay.getDate() + ' ' + this.header.attr('data-day-suffix') + ' ' + this.headCopy;
    } else {
      headOut = this.headCopy + ' ' + this.months[this.firstDay.getMonth()] + ' ' + this.firstDay.getDate() + ', ' + this.firstDay.getFullYear();
    }

    this.headContent.html(headOut);

    this.lArrow.off('click');
    this.rArrow.off('click');

    this.rArrow.css('cursor', 'pointer').click(function (e) {
      e.preventDefault();
      var nextDate = new Date(me.firstDay.getTime());

      nextDate.setDate(nextDate.getDate() + 7);

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({ date: nextDate });
    });

    this.lArrow.css('cursor', 'pointer').click(function (e) {
      e.preventDefault();
      var prevDate = new Date(me.firstDay.getTime());

      prevDate.setDate(prevDate.getDate() - 7);

      me.rArrow.css('cursor', 'default').off('click');
      me.lArrow.css('cursor', 'default').off('click');
      me.model.update({ date: prevDate });
    });
  };

  /**
   * CalendarTimeSlots is a class for concrete views of the CalendarModel.
   * It displays and manages the display logic for the Desktop Calendar Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlots = function (options) {
    apptBook.CalendarTimeSlots.superclass.constructor.call(this);
    this.initialized = false;
    this.container = options.container;
    this.colHeads = options.colHeads;
    this.timeSlotRow = options.timeSlotRow;
    this.timeSlotsContainer = options.timeSlotsContainer;
    this.days = options.dayNames;
    this.months = options.monthNames;
    this.slotLabels = options.slotLabels;

    this.slots = [];
    var start_hour_time = this.container.attr('cal-start-hour') || 8;
    var end_hour_time = this.container.attr('cal-end-hour') || 23;
    var time_difference = end_hour_time - start_hour_time;

    for (var i = 0; i <= time_difference; i++) {
      if (time_interval) {
        for (var j = 0, k = 0; j < 60; k++) {
          this.slots.push({ hour: (parseInt(start_hour_time) + i) + ':' + k * time_interval });
          j = parseInt(j) + parseInt(time_interval);
        }
      } else {
        this.slots.push({ hour: parseInt(start_hour_time) + i });
      }
    }
    for (var i = 0, len = this.slots.length; i < len; i += 1) {
      if (this.slotLabels && this.slotLabels[i]) {
        this.slots[i].label = this.slotLabels[i];
      } else {
        this.slots[i].label = '&nbsp;';
      }
    }
  };

  ctrlopt.extend(apptBook.CalendarTimeSlots, ctrlopt.mvc.AbstractView);

  apptBook.CalendarTimeSlots.prototype.defaultController = function (data) {
    return null;
  };

  apptBook.CalendarTimeSlots.prototype.onUpdate = function (data) {
    this.calData = data;
    this.buildWeekView();
  };

  apptBook.CalendarTimeSlots.prototype.buildWeekView = function () {
    var hText, sText, hour, row, len = 7,
      myDate = this.calData.myDate,
      dayOfWeek = startDayShift(myDate.getDay());

    // this.date = myDate.getDate();
    // this.month = myDate.getMonth();
    // this.year = myDate.getFullYear();
    this.firstDay = new Date(myDate.getTime());
    this.firstDay.setDate(this.firstDay.getDate() - dayOfWeek);
    this.firstDay.setHours(0);
    this.lastDay = new Date(this.firstDay.getTime());
    this.lastDay.setDate(this.lastDay.getDate() + 6);
    this.lastDay.setHours(23, 59, 59, 999);

    for (var i = 0; i < len; i += 1) {
      var myDayDate = new Date(this.firstDay.getTime());

      myDayDate.setDate(myDayDate.getDate() + i);
      if (oab_date_month_override) {
        hText = this.days[i] + ' ' + ('00' + myDayDate.getDate()).slice(-2) + '/' + ('00' + this.months[myDayDate.getMonth()]).slice(-2);
      } else if (oab_date_format) {
        hText = this.months[myDayDate.getMonth()] + '/' + myDayDate.getDate() + ' ' + this.days[i];
      } else {
        hText = this.days[i] + ' ' + myDayDate.getDate() + '/' + this.months[myDayDate.getMonth()];
      }
      this.colHeads.eq(i).removeClass('hilite').text(hText);
    }

    if (this.calData.hilite) {
      this.colHeads.eq(dayOfWeek).addClass('hilite');
    }

    this.timeSlotsContainer.empty();
    len = this.slots.length;
    i = 0;
    for (; i < len; i += 1) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      row = this.timeSlotRow.clone();
      row.find('td').attr('data-hour', hour).text(sText);
      this.timeSlotsContainer.append(row);
    }
    this.timeSlotsElems = this.timeSlotsContainer.find('td');
    this.setSlots();

    if (this.calData.apptTime) {
      this.setApptTime();
    }
  };

  apptBook.CalendarTimeSlots.prototype.processSlot = function (start, end) {
    var startIndex,
      myDayOfWeek = startDayShift(start.getDay()),
      col = this.timeSlotsContainer.find('.day-' + myDayOfWeek),
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this,
      start_hr = start.getHours(),
      start_min = start.getMinutes(),
      startHour;

    if (time_interval) {
      if (time_interval < start_min) {
        startHour = start_hr + 1 + ':0';
      } else if (start_min === 0) {
        startHour = start_hr + ':0';
      } else if (time_interval >= start_min) {
        startHour = start_hr + ':' + time_interval;
      }
    } else {
      startHour = start_min === 0 ? start_hr : start_hr + 1;
    }

    for (var i = 0; i < len; i += 1) {
      if (this.slots[i].hour === startHour) {
        startIndex = i;
        break;
      }
    }

    for (i = startIndex; i < len; i += 1) {
      var timeLeft, minLeft,
        sHr = this.slots[i].hour,
        set_Hr = time_interval ? sHr.split(':')[0] : sHr,
        set_Min = time_interval ? sHr.split(':')[1] : 0;

      sHrDate.setHours(set_Hr, set_Min, 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDur) {
        break;
      } else {
        col.eq(i).addClass('enabled').click(function (e) {
          var slotDate = new Date(start.getTime()),
            $this = $(this);

          me.timeSlotsElems.removeClass('selected');
          $(this).addClass('selected');
          slotDate.setHours(parseInt($this.attr('data-hour'), 10));
          if (time_interval) {
            slotDate.setMinutes(parseInt($this.attr('data-hour').split(':')[1]));
          }
          me.model.setSelection(slotDate);
        });
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots;

    if (!timeslots) {
      return;
    }

    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        end = this.convertTimeString(timeslots[i].end_date),
        startTime = start.getTime();

      if (startTime >= this.firstDay.getTime() && startTime <= this.lastDay.getTime()) {
        this.processSlot(start, end);
      }
    }
  };

  apptBook.CalendarTimeSlots.prototype.setApptTime = function () {
    var me = this,
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString();

    if (apptTime >= this.firstDay.getTime() && apptTime <= this.lastDay.getTime()) {
      this.timeSlotsContainer.find('.day-' + startDayShift(apptDate)).each(function () {
        var $this = $(this);

        if ($this.attr('data-hour') === apptHour) {
          $this.addClass('selected').addClass('enabled');
          me.model.setSelection(apptDate);
        }
      });
    }
  };

  apptBook.CalendarTimeSlots.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  /**
   * CalDatePicker is a class faor a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePicker = function (options) {
    apptBook.CalDatePicker.superclass.constructor.call(this);
    var offSet,
      me = this,
      $bod = options.jqBod,
      overlay = options.overlay,
      closeBtn = options.closeBtn,
      calContainer = options.calContainer,
      weekContainer = options.weekContainer,
      dpField = options.datepickerField,
      dpTrigger = options.datepickerTrigger,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      pikaday = new Pikaday(
        {
          field: dpField[0],
          firstDay: parseInt(start_day),
          minDate: new Date(),
          maxDate: new Date(2020, 12, 31),
          yearRange: [2000, 2020],
          showMonthAfterYear: oab_show_month_after_year ? true : false,
          yearSuffix: oab_show_year_suffix ? year_suffix : '',
          bound: false,
          container: calContainer[0],
          numberOfMonths: 2,
          onSelect: onDateSelect,
          i18n: {
            /* previousMonth : 'Previous Month',
          nextMonth     : 'Next Month',*/
            months: months,
            weekdays: days,
            weekdaysShort: days
          }
        }
      );

    $bod.prepend(overlay);

    function openOverlay() {
      overlay.css('display', 'block');
      pikaday.gotoDate(new Date());
    }

    function closeOverlay() {
      overlay.css('display', 'none');
    }

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
      closeOverlay();
    }

    dpTrigger.click(openOverlay);
    closeBtn.click(closeOverlay);
    // dpField.change(onDateSelect);
  };

  ctrlopt.extend(apptBook.CalDatePicker, ctrlopt.mvc.AbstractController);

  /* Mobile Appointment Select */

  /* Mobile Date Picker - Date Picker */

  /**
   * CalDatePickerMobile is a sub-class of CalDatePicker. It is a concrete controller of the CalendarModel.
   * It manages the pickaday date picker and uses its input to update the Calendar Model
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalDatePickerMobile = function (options) {
    apptBook.CalDatePickerMobile.superclass.constructor.call(this);
    var me = this,
      calContainer = options.calContainer,
      dpField = options.datepickerField,
      days = options.dayNames,
      months = options.monthNames,
      year_suffix = options.yearSuffix,
      pikaday = new Pikaday(
        {
          field: dpField[0],
          firstDay: parseInt(start_day),
          minDate: new Date(),
          maxDate: new Date(2020, 12, 31),
          yearRange: [2000, 2020],
          showMonthAfterYear: oab_show_month_after_year ? true : false,
          yearSuffix: oab_show_year_suffix ? year_suffix : '',
          bound: false,
          container: calContainer[0],
          onSelect: onDateSelect,
          i18n: {
            /* previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',*/
            months: months,
            weekdays: days,
            weekdaysShort: days
          }
        }
      );

    function onDateSelect(e) {
      var d = pikaday.getDate();

      if (me.model) {
        me.model.update({
          date: d,
          hilite: true
        });
      }
    }
  };

  ctrlopt.extend(apptBook.CalDatePickerMobile, ctrlopt.mvc.AbstractController);

  /* End Mobile Date Picker */

  /* Mobile Calendar Header */

  /**
   * CalendarHeaderMobile is a sub-class of CalendarHeader. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Desktop Time Slot Calendar Header.
   *
   *
   * @param header JQuery required    a jquery object that contains a DOM element that represents the root element of the
   *                                  header.
   *
   *
   * @constructor
   */

  apptBook.CalendarHeaderMobile = function (header) {
    apptBook.CalendarHeaderMobile.superclass.constructor.call(this);
    this.initialized = false;
    this.header = header;
    this.headCopy = this.header.html();
    this.months = this.header.attr('data-months').split(',');
  };

  ctrlopt.extend(apptBook.CalendarHeaderMobile, ctrlopt.mvc.AbstractView);

  apptBook.CalendarHeaderMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    var headOut,
      me = this,
      myDate = this.calData.myDate;

    if (oab_date_override) {
      headOut = this.headCopy + ' ' + myDate.getDate() + oab_date_month_separator + this.months[myDate.getMonth()];
    } else if (oab_date_format) {
      headOut = this.months[myDate.getMonth()] + ' ' + myDate.getDate() + this.header.attr('data-day-suffix') + ' ' + this.headCopy;
    } else {
      headOut = this.headCopy + ' ' + this.months[myDate.getMonth()] + ' ' + myDate.getDate();
    }
    this.header.html(headOut);
  };

  /* End Mobile Calendar Header */

  /* Mobile Time Slot Select */

  /**
   * CalendarTimeSlotsMobile is a sub-class of CalendarTimeSlots. It is a concrete view of the CalendarModel.
   * It displays and manages the display logic for the Mobile Time Slot Selector.
   *
   *
   * @param options Object required
   *
   *
   * @constructor
   */

  apptBook.CalendarTimeSlotsMobile = function (options) {
    apptBook.CalendarTimeSlotsMobile.superclass.constructor.call(this, options);
  };

  ctrlopt.extend(apptBook.CalendarTimeSlotsMobile, apptBook.CalendarTimeSlots);

  apptBook.CalendarTimeSlotsMobile.prototype.onUpdate = function (data) {
    this.calData = data;
    if (!this.initialized) {
      this.buildWeekView();
      this.initialized = true;
    } else {
      this.tdElems.removeClass('selected');
      this.setSlots();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.buildWeekView = function () {
    var hour, sText, row, rowCount, rows, rowIdx, tds, tdPerRow, tdElem, mod, cur, td;

    tds = this.timeSlotRow.find('td').remove();
    tdPerRow = tds.length;
    tdElem = tds.first();
    rowCount = Math.ceil(this.slots.length / tdPerRow);

    for (var i = 0; i < rowCount; i += 1) {
      row = this.timeSlotRow.clone();
      this.timeSlotsContainer.append(row);
    }

    rows = this.timeSlotsContainer.find('tr');
    i = 0;
    rowIdx = 0;
    for (var len = this.slots.length; i < len; i += 1) {
      sText = this.slots[i].label;
      hour = this.slots[i].hour;
      td = tdElem.clone();
      td.attr('data-hour', hour).text(sText);
      rows.eq(rowIdx).append(td);

      cur = i + 1;
      mod = cur % tdPerRow;

      if (mod === 0) {
        rowIdx += 1;
      }
    }
    this.tdElems = this.timeSlotsContainer.find('td');
    this.setSlots();

    if (this.calData.apptTime) {
      this.setApptTime();
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.processSlot = function (start, end) {
    var startIndex,
      sHrDate = new Date(start.getTime()),
      len = this.slots.length,
      me = this,
      start_hr = start.getHours(),
      start_min = start.getMinutes(),
      startHour;

    if (time_interval) {
      if (time_interval < start_min) {
        startHour = start_hr + 1 + ':0';
      } else if (start_min === 0) {
        startHour = start_hr + ':0';
      } else if (time_interval >= start_min) {
        startHour = start_hr + ':' + time_interval;
      }
    } else {
      startHour = start_min === 0 ? start_hr : start_hr + 1;
    }

    for (var i = 0; i < len; i += 1) {
      if (this.slots[i].hour === startHour) {
        startIndex = i;
        break;
      }
    }

    for (i = startIndex; i < len; i += 1) {
      var timeLeft, minLeft,
        sHr = this.slots[i].hour,
        set_Hr = time_interval ? sHr.split(':')[0] : sHr,
        set_Min = time_interval ? sHr.split(':')[1] : 0;

      sHrDate.setHours(set_Hr, set_Min, 0, 0);
      timeLeft = end.getTime() - sHrDate.getTime();
      minLeft = Math.floor(timeLeft / 60000);

      if (minLeft < this.calData.apptDur) {
        break;
      } else {
        this.tdElems.eq(i).addClass('enabled').click(function (e) {
          var slotDate = new Date(start.getTime()),
            $this = $(this);

          me.tdElems.removeClass('selected');
          $(this).addClass('selected');
          slotDate.setHours(parseInt($this.attr('data-hour'), 10));
          if (time_interval) {
            slotDate.setMinutes(parseInt($this.attr('data-hour').split(':')[1]));
          }
          me.model.setSelection(slotDate);
        });
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setSlots = function () {
    var timeslots = this.calData.timeslots,
      myDate = new Date(this.calData.myDate.getTime());

    myDate.setHours(0, 0, 0, 0);

    this.tdElems.removeClass('enabled').off('click');

    if (!timeslots) {
      return;
    }
    for (var i = 0, len = timeslots.length; i < len; i += 1) {
      var start = this.convertTimeString(timeslots[i].start_date),
        startDay = new Date(start.getTime());

      startDay.setHours(0, 0, 0, 0);

      if (startDay.getTime() === myDate.getTime()) {
        this.processSlot(start, this.convertTimeString(timeslots[i].end_date));
      }
    }
  };

  apptBook.CalendarTimeSlotsMobile.prototype.setApptTime = function () {
    var me = this,
      apptDate = this.convertTimeString(this.calData.apptTime),
      apptTime = apptDate.getTime(),
      apptHour = apptDate.getHours().toString();
  };

  /* End Mobile Time Slot Select */

  Drupal.behaviors.apptBookAppointments = {
    attach: function (context) {
      var view = new apptBook.AppointmentSelectSection($('#appointments'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
